export function initLoadMoreList(options) {
    if (!options) return;
    const button = document.querySelector(options.buttonSelector);
    const container = document.querySelector(options.containerSelector);
    const params = options.params || {};

    if (!button || !container || !options.action || !params.ajaxurl) return;

    // Prevent multiple inits
    if (button.dataset.loadMoreInited === '1') return;
    button.dataset.loadMoreInited = '1';

    button.style.cursor = 'pointer';

    button.addEventListener('click', function(e) {
        e.preventDefault();

        const nameEl = button.querySelector('.name');
        if (nameEl === null) {
            return;
        }

        const isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
        const hiddenItems = container.querySelectorAll('article.is-mobile-hidden');
        if (isMobile && hiddenItems.length > 0) {
            const toReveal = Math.min(2, hiddenItems.length);
            for (let i = 0; i < toReveal; i++) {
                hiddenItems[i].classList.remove('is-mobile-hidden');
            }
            const totalDisplayed = container.querySelectorAll('article').length;
            if (totalDisplayed >= (params.total || 0)) {
                button.remove();
            }
            return;
        }

        const currentCount = container.querySelectorAll('article').length;

        const data = new FormData();
        data.append('action', options.action);
        data.append('offset', String(currentCount));
        data.append('per_page', String(params.per_page || 2));
        if (params.nonce) {
            data.append('nonce', params.nonce);
        }

        nameEl.textContent = params.translation_loading || nameEl.textContent;
        button.disabled = true;

        fetch(params.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            body: data
        })
        .then((response) => response.text())
        .then((html) => {
            button.disabled = false;
            if (html !== '') {
                nameEl.textContent = params.translation_read_more || nameEl.textContent;
                container.insertAdjacentHTML('beforeend', html);

                const totalDisplayed = container.querySelectorAll('article').length;
                if (totalDisplayed >= (params.total || 0)) {
                    button.remove();
                }
            } else {
                button.remove();
            }
        })
        .catch(() => {
            button.disabled = false;
            nameEl.textContent = params.translation_read_more || nameEl.textContent;
        });
    });
}


